import { configValue } from 'utils/config';

const getPostSearchIndex = () => configValue('algolia', 'contentIndexName');

// eslint-disable-next-line import/no-default-export
export default getPostSearchIndex;
